export default {
  circleBorderColor: 'brandOne100',
  circleHoverBorderColor: 'brandTwo100',
  circleHoverBackgroundColor: 'brandTwo100',
  hoverColour: 'brandOne100',
};
